<section class="main-wrap inner-views dashboard-wrap lens-module" [ngClass]="{ 'menu-open in': !toggleClass }">

  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>

      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>

  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>
    <div class="content-container products-container single-product lens-module lens-perscription">
      <div class="row">
        <div class="col-md-6">
          <div class="lens-module-data">
            <app-product-data></app-product-data>
          </div>
        </div>
        <div class="col-md-6">
          <div class="prod-col-in">
            <h2 class="prod-title">
              Lens Selection
            </h2>
            <div class="progress" style="height: 7px;">
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar" role="progressbar" style="width: 25%;"></div>
            </div>
            <div class="clearfix"></div>
            @if (companyLensTypeVM) {
              <div class="col-md-12 module-non-prescription">
                <h3>Prescription</h3>
                <p>Lenses with a prescription as provided by your doctor</p>
                @if (isSingleVisionRecommended) {
                  <div class="non-prescription-data">
                    <p><strong>Based on your prescription history, we suggest Single Vision.</strong></p>
                  </div>
                } @else {
                  <p><strong>Based on your prescription history, we suggest Bifocal / Progressive.</strong></p>
                }
              </div>
              <div class="col-md-12 module-options" [ngClass]="{ 'suggested-item': isSingleVisionRecommended }">
                @if (isSingleVisionRecommended) {
                  <img src="assets/images/icons/orange-arrow-27x19.svg" width="27" height="19" alt="Arrow Icon">
                }
                <h3>Single Vision Lenses</h3>
                <button (click)="showGuidedOpticianModal(LENS_TYPES.singleVision)"><img height="15" src="assets/images/icons/angle-right-solid.svg" width="15" alt="Angle Right Icon"/></button>
              </div>
              <div class="col-md-12 module-options" [ngClass]="{ 'suggested-item': !isSingleVisionRecommended }">
                @if (!isSingleVisionRecommended) {
                  <img src="assets/images/icons/orange-arrow-27x19.svg" width="27" height="19" alt="Arrow Icon">
                }
                <h3>Bifocal / Progressive Lenses</h3>
                <button (click)="showGuidedOpticianModal(LENS_TYPES.bifocalProg)"><img height="15" src="assets/images/icons/angle-right-solid.svg" width="15" alt="Angle Right Icon"/></button>
              </div>
              <div class="col-md-12 module-nav next-step">
                <a class="btn product-btn gray-btn" [routerLink]="['/lens-selection']">Back</a>
                <button class="btn product-btn gray-btn" (click)="_orderManagerService.verifyLensSelection(isEditMode)" type="button">Next</button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


